import * as React from "react";
import Paper from "@mui/material/Paper";
import { useEffect, useState } from "react";
import {
    Box,
    Button,
    Divider,
    Modal,
    Stack,
    Tooltip,
    Typography,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Card from "@mui/material/Card";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import {
    DataGrid,
    GridColDef,
    GridToolbar,
} from "@mui/x-data-grid";

import DataGrids from "../../../utils/Datagrids";
import dayjs from "dayjs";
import ToastApp from "../../../ToastApp";
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import nopdf from '../../../assets/images/imagepreview.jpg';
import VisibilityIcon from '@mui/icons-material/Visibility';
import api from "../../../utils/Url";
interface MenuPermission {
    isAdd: boolean;
    isEdit: boolean;
    isPrint: boolean;
    isDel: boolean;
}


const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "180vh",
    height: "85vh",
    bgcolor: "#f5f5f5",
    border: "1px solid #000",
    boxShadow: 24,
    p: 4,
    borderRadius: 10,
};

export default function MrnDetails() {
    const [item, setItem] = useState([]);
    const [columns, setColumns] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [Shows, setShows] = useState<boolean>(false);
    const [IsRep, setRep] = useState<any>("");


    let navigate = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
        // const dataString = localStorage.getItem("userdata");
        //   if (dataString) {
        //     const data = JSON.parse(dataString);
        //     if (data && data.length > 0) {
        //       const userPermissionData = data[0]?.userPermission;
        //       if (userPermissionData && userPermissionData.length > 0) {
        //         const menudata = userPermissionData[0]?.parentMenu;
        //         for (let index = 0; index < menudata.length; index++) {
        //           const childMenudata = menudata[index]?.childMenu;
        //           const pathrow = childMenudata.find(
        //             (x: any) => x.path === location.pathname
        //           );
        //           console.log("data", pathrow);
        //           if (pathrow) {
        //             setPermissionData(pathrow);
        fetchZonesData();
        //         }
        //       }
        //     }
        //   }
        // }
    }, [isLoading]);


    const routeChangeEdit = (row: any) => {
        console.log("row " + row);

        let path = `/Inventory/MrnDetailsEdit`;
        navigate(path, {
            state: row,
        });
    };

    const routeChangeAdd = () => {
        let path = `/Inventory/MrnDetailsAdd`;
        navigate(path);
    };

    let delete_id = "";

    const accept = () => {
        const collectData = {
            id: delete_id,
        };
        console.log("collectData " + JSON.stringify(collectData));
        api
            .post(`api/PurchaseInvoice/DeletePurchaseInvoice`, collectData)
            .then((response) => {
                if (response.data.isSuccess) {
                    toast.success(response.data.mesg);
                } else {
                    toast.error(response.data.mesg);
                }
                fetchZonesData();
            });
    };

    const reject = () => {
        // toast.warn({summary: 'Rejected', detail: 'You have rejected', life: 3000 });
        toast.warn("Rejected: You have rejected", { autoClose: 3000 });
    };

    const handledeleteClick = (del_id: any) => {
        // console.log(del_id + " del_id ");
        delete_id = del_id;
        confirmDialog({
            message: "Do you want to delete this record ?",
            header: "Delete Confirmation",
            icon: "pi pi-info-circle",
            acceptClassName: "p=-button-danger",
            accept,
            reject,
        });
    };


    const handlePrint = async (Id: any) => {
        const collectData = {
            id: Id,
            "isRequst": true,
            "document_No": "",

            "show": false,
            "exportOption": ".pdf",
        };
        // console.log("collectData " + JSON.stringify(collectData));
        const response = await api.post(
            `api/PurchaseInvoice/GetPurchaseInvoice`,
            collectData
        );


        if (response) {


            //console.log('Printdata',data)
            setShows(true);
            setRep(response.data);

        }
    };


    const fetchZonesData = async () => {
        try {
            const collectData = {
                "MrnId": -1,
                "show": true,
                "exportOption": "",
                "type": 0

            };
            const response = await api.get(
                `Mrn/GetMrn`,
                { params: collectData }
            );
            const data = response.data.data;
            const IndentWithIds = data.map((Item: any, index: any) => ({
                ...Item,
                serialNo: index + 1,
                id: Item.MrnId,
            }));
            setItem(IndentWithIds);
            setIsLoading(false);

            if (data.length > 0) {
                const columns: GridColDef[] = [
                    {
                        field: "actions",
                        headerClassName: "MuiDataGrid-colCell",
                        headerName: t("text.Action"),
                        width: 100,

                        renderCell: (params) => {
                            return [
                                <Stack
                                    spacing={1}
                                    direction="row"
                                    sx={{ alignItems: "center", marginTop: "5px" }}
                                >
                                    {/* {permissionData?.isEdit ? ( */}
                                    <EditIcon
                                        style={{
                                            fontSize: "20px",
                                            color: "blue",
                                            cursor: "pointer",
                                        }}
                                        className="cursor-pointer"
                                        onClick={() => routeChangeEdit(params.row)}
                                    />
                                    {/* ) : ( */}
                                    {/* "" */}
                                    {/* )} */}
                                    {/* {permissionData?.isDel ? ( */}
                                    <DeleteIcon
                                        style={{
                                            fontSize: "20px",
                                            color: "red",
                                            cursor: "pointer",
                                        }}
                                        onClick={() => {
                                            handledeleteClick(params.row.id);
                                        }}
                                    />

                                    <VisibilityIcon
                                        style={{
                                            fontSize: "20px",
                                            color: "#65b7c9",
                                            cursor: "pointer",
                                        }}
                                        onClick={() => {
                                            handlePrint(params.row.id);
                                        }}
                                    />
                                </Stack>,
                            ];
                        },
                    },

                    // {
                    //     field: "serialNo",
                    //     headerName: t("text.SrNo"),
                    //     flex: 1,
                    //     headerClassName: "MuiDataGrid-colCell",
                    // },
                    {
                        field: "vendorName",
                        headerName: t("text.supplierNames"),
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                    },
                    {
                        field: "bill_ChalanNo",
                        headerName: t("text.BillChalanNo"),
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                    },
                    {
                        field: "shipmentNo",
                        headerName: t("text.ShipmentNo"),
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                    },
                    {
                        field: "mrnDate",
                        headerName: t("text.MrnDate"),
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                        renderCell(params) {
                            return dayjs(params.row.mrnDate).format("DD-MMM-YYYY")
                        },
                    },
                    {
                        field: "bill_ChalanDate",
                        headerName: t("text.BillChalanDate"),
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                        renderCell(params) {
                            return dayjs(params.row.bill_ChalanDate).format("DD-MMM-YYYY")
                        },
                    },

                    {
                        field: "totalAmount",
                        headerName: t("text.TotalAmounts"),
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                    },



                    {
                        field: "totalGrossAmount",
                        headerName: t("text.GrossAmounts"),
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                        // renderHeader: (params) => (
                        //     <Tooltip title={"Total Gross Amount"} arrow>
                        //         <span>{"Total Gross Amount"}</span>
                        //     </Tooltip>
                        // ),
                    },


                    {
                        field: "remark",
                        headerName: t("text.Remark"),
                        flex: 1,
                        headerClassName: "MuiDataGrid-colCell",
                    },

                ];
                setColumns(columns as any);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            // setLoading(false);
        }
    };

    const adjustedColumns = columns.map((column: any) => ({
        ...column,
    }));


    return (
        <>
            <Card
                style={{
                    width: "100%",
                    // height: "100%",
                    backgroundColor: "#E9FDEE",
                    border: ".5px solid #FF7722 ",
                    marginTop: "3vh"
                }}
            >
                <Paper
                    sx={{
                        width: "100%",
                        overflow: "hidden",
                        "& .MuiDataGrid-colCell": {
                            backgroundColor: `var(--grid-headerBackground)`,
                            color: `var(--grid-headerColor)`,
                            fontSize: 17,
                            fontWeight: 900
                        },
                    }}
                    style={{ padding: "10px", }}
                >
                    <ConfirmDialog />

                    <Typography
                        gutterBottom
                        variant="h5"
                        component="div"
                        sx={{ padding: "20px" }}
                        align="left"
                    >
                        {t('text.MrnDetails')}
                    </Typography>
                    <Divider />

                    <Box height={10} />

                    <Stack direction="row" spacing={2} classes="my-2 mb-2">
                        {/* {permissionData?.isAdd == true && ( */}
                        <Button
                            onClick={routeChangeAdd}
                            variant="contained"
                            endIcon={<AddCircleIcon />}
                            size="large"
                            style={{ backgroundColor: `var(--header-background)` }}
                        >
                            {t("text.add")}
                        </Button>
                        {/* ) } */}

                        {/* {permissionData?.isPrint == true ? (
              <Button variant="contained" endIcon={<PrintIcon />} size="large">
                {t("text.print")}
              </Button>
            ) : (
              ""
            )} */}
                    </Stack>


                    <DataGrids
                        isLoading={isLoading}
                        rows={item}
                        columns={adjustedColumns}
                        pageSizeOptions={[5, 10, 25, 50, 100]}
                        initialPageSize={5}
                    />



                    <Modal open={Shows} onClose={() => setShows(false)}>
                        <Box sx={style}>
                            {IsRep ? (
                                <embed src={`data:application/pdf;base64,${IsRep}`} type="application/pdf" style={{ width: "100%", height: "100%" }} />
                            ) : (
                                <img
                                    src={nopdf}
                                    alt="No Preview"
                                    style={{ width: "100%", height: "100%" }}
                                />
                            )}
                        </Box>
                    </Modal>
                </Paper>
            </Card>
            <ToastApp />

        </>
    );
}
